import VueRouter from 'vue-router';
import Home from '@c/pages/Home';
//import Brands from '@c/pages/OldBrands';
import Brands from '@c/pages/Brands';
import Boss from '@c/pages/Brands/Boss';
import Mud from '@c/pages/Brands/Mud';
import Prosafety from '@c/pages/Brands/Prosafety';
import Safetyworks from '@c/pages/Brands/Safetyworks';
import Hearos from '@c/pages/Brands/Hearos';
import WCG from '@c/pages/Brands/WCGardener';
import Company from '@c/pages/About'
import Category from '@c/pages/Category';
import Product from '@c/product/Product';
import SpecSheetPartOne from '@c/product/SpecSheetPartOne';
import SpecSheetPartTwo from '@c/product/SpecSheetPartTwo';
import Literature from '@c/pages/Literature';
import Videos from '@c/pages/sales-tools/Videos';
import Learning from '@c/pages/sales-tools/Learning';
import HandProtectionExperts from '@c/pages/sales-tools/Hand-protection-experts';
import HiVisApparelExperts from '@c/pages/sales-tools/Hi-vis-apparel-experts';
import HeadProtectionExperts from '@c/pages/sales-tools/Head-protection-experts';
import EarProtectionExperts from '@c/pages/sales-tools/Ear-protection-experts';
import EyeProtectionExperts from '@c/pages/sales-tools/Eye-protection-experts';
import EN388Standards from '@c/pages/sales-tools/standards-en388';
import ANSI105Standards from '@c/pages/sales-tools/standards-ansi105';
import ANSI107Standards from '@c/pages/sales-tools/standards-ansi107';
import Contact from '@c/pages/Contact';
import Login from './auth/Login';
import PriceListPortal from '@c/dashboard/PriceListPortal';
import EmailSignature from '@c/dashboard/EmailSignature';
import VectorView from '@c/dashboard/VectorView';
import MyTools from '@c/dashboard/MyTools';
import Account from '@c/dashboard/Account';
import EditUser from '@c/dashboard/EditUser';
import NoAccess from '@c/dashboard/NoAccess';
import NoAdminAccess from '@c/dashboard/NoAdminAccess';
import ChangePassword from '@c/dashboard/ChangePassword';
import ChangeUserPassword from '@c/dashboard/EditUserPassword';
import SpecSheetDownload from '@c/dashboard/SpecSheetDownload';
import PageNotFound from '@c/pages/PageNotFound';
import ResetPassword from './auth/ResetPassword';
import ForgotPassword from './auth/ForgotPassword';
import PrivacyPolicy from '@c/pages/PrivacyPolicy';
import CookiePolicy from '@c/pages/CookiePolicy';
import KnowUs from '../../resources/js/components/about-us/KnowUs';
import Locations from '../../resources/js/components/about-us/Locations';
import CareerOpportunities from '../../resources/js/components/about-us/CareerOpportunities';
import TradeShow from '../../resources/js/components/about-us/TradeShow.vue';
import UserVerification from '@c/dashboard/UserVerification';
import SearchUser from '@c/dashboard/SearchUser';
import MainLayout from './layouts/MainLayout';
import UnAuthorizedPriceListPortal from '@c/pricelist/UnauthorizedPriceListPortal';
import PriceWorkflowDashboards from '@c/price-deviation/PriceWorkflowDashboards';
import PriceWorkflowSubmission from '@c/price-deviation/PriceWorkflowSubmission';
import PriceWorkflowCompanySelect from '@c/price-deviation/PriceWorkflowCompanySelect';
import PriceWorkflowStyleSelect from '@c/price-deviation/PriceWorkflowStyleSelect';
import PriceWorkflowSkuSelect from '@c/price-deviation/PriceWorkflowSkuSelect';
import PriceWorkflowPricing from '@c/price-deviation/PriceWorkflowPricing';
import PriceWorkflowSignoff from '@c/price-deviation/PriceWorkflowSignoff';
import PriceWorkflowLevelDeviation from '@c/price-deviation/PriceWorkflowLevelDeviation';
import PriceWorkflowCustomDiscount from '@c/price-deviation/PriceWorkflowCustomDiscount';
import PriceLevelSignoff from '@c/price-deviation/PriceLevelSignoff';
import PriceWorkflowCustomDiscountSignoff from '@c/price-deviation/PriceWorkflowCustomDiscountSignoff';
import PriceWorkflowPromoType from '@c/price-deviation/PriceWorkflowPromoType';
import PriceWorkflowPromoDetails from '@c/price-deviation/PriceWorkflowPromoDetails';
import PriceWorkflowViewPromo from '@c/price-deviation/PriceWorkflowViewPromo';
import DynamicPriceList from '@c/dashboard/DynamicPriceList';
import ImageGallery from '@c/image-download-gallery/ImageGallery';
import ImageGalleryResults from '@c/image-download-gallery/ImageGalleryResults';

function guardMyroute(to,from,next)
    {
        if(localStorage.getItem('isLoggedIn')=="false" || !localStorage.getItem('isLoggedIn') && (localStorage.getItem('approved')!="y" || !localStorage.getItem('approved')) &&  (localStorage.getItem('userType')=="1" || !localStorage.getItem('userType') )){

        //checking if user is logged in
        // next({ path: '/auth/login' });
        next({ name: 'login' , query: { from: to.name } });
    }else{
        next();
    }
}

// function guardMyroute(to,from,next)
//     {
//     if((localStorage.getItem('isLoggedIn')=="false" || !localStorage.getItem('isLoggedIn')) && (localStorage.getItem('approved')!="y" || !localStorage.getItem('approved')) &&  (localStorage.getItem('userType')=="1" || !localStorage.getItem('userType') )){
//         next('/NoAccess'); // go to '/NoAccess';
//     }else{
//         next();
//     }
// }

function guardAdminTools(to,from,next)
    {
    if(localStorage.getItem('isLoggedIn')=="true" && localStorage.getItem('approved')=="y" &&  localStorage.getItem('userType')=="8"){
        next();
    }else{

        next('/NoAdminAccess'); // go to '/NoAccess';

    }
}



function guardMyPriceListPortal(to,from,next)
    {
    if(localStorage.getItem('isLoggedIn')=="false" || !localStorage.getItem('isLoggedIn')){
        next('/PriceListVerify'); // go to '/PriceListVerify';
    }else{
        next();
    }
}

const routes = [

    {
        path: "/",
        component: MainLayout,
        children:[
            {
                path: "",
                component: Home,
                name: 'home'
            },
            {
                path: "/VectorView",
                component: VectorView,
                name:'vector-view',
                beforeEnter:guardMyroute,
            },
            {
                path: "/EmailSignature",
                component: EmailSignature,
                name:'email-signature',
                beforeEnter:guardMyroute,
            },
            {
                path: "/VerifyUser",
                component: UserVerification,
                name:'verify-user',
                beforeEnter:guardAdminTools,
            },
            {
                path: "/SearchUser",
                component: SearchUser,
                name:'search-user',
                beforeEnter:guardAdminTools,
            },
            {
                path: "/brands",
                component: Brands,
                name: 'brand'
            },
            {
                path: "/products",
                component: Category,
                name: 'products',
                meta: {
                    title: 'Products | West Chester Gear'
                }
            },
            {
                path: "/product/:id",
                component: Product,
                name: 'product'
            },
            {
                path: "/company",
                component: Company,
                name: 'company'
            },

            {
                path: "/brands",
                component: { template: '<router-view></router-view>' },
                children: [
                    {
                        path: "boss",
                        component: Boss,
                        name: 'boss'
                    },
                    {
                        path: "mud",
                        component: Mud,
                        name: 'mud'
                    },
                    {
                        path: "prosafety",
                        component: Prosafety,
                        name: 'prosafety'
                    },
                    {
                        path: "safetyworks",
                        component: Safetyworks,
                        name: 'safetyworks'
                    },
                    {
                        path: "hearos",
                        component: Hearos,
                        name: 'hearos'
                    },
                    {
                        path: "westcountygardener",
                        component: WCG,
                        name: 'westcountygardener'
                    },
                ]
            },

            {
                path: "/sales-tools",
                component: { template: '<router-view></router-view>' },
                children: [
                    {
                        path: "videos",
                        component: Videos,
                        name: 'videos'
                    },

                    {
                        path: "learning",
                        component: Learning,
                        name: 'learning'
                    },

                    {
                        path: "literature",
                        component: Literature,
                        name: 'literature'
                    },

                    {
                        path: "hand-protection-experts",
                        component: HandProtectionExperts,
                        name: 'handprotectionexperts'
                    },

                    {
                        path: "hi-vis-apparel-experts",
                        component: HiVisApparelExperts,
                        name: 'hivisapparelexperts'
                    },

                    {
                        path: "head-protection-experts",
                        component: HeadProtectionExperts,
                        name: 'headprotectionexperts'
                    },

                    {
                        path: "ear-protection-experts",
                        component: EarProtectionExperts,
                        name: 'earprotectionexperts'
                    },

                    {
                        path: "eye-protection-experts",
                        component: EyeProtectionExperts,
                        name: 'eyeprotectionexperts'
                    },

                    {
                        path: "standards-en388",
                        component: EN388Standards,
                        name: 'en388standards'
                    },

                    {
                        path: "standards-ansi105",
                        component: ANSI105Standards,
                        name: 'ansi105standards'
                    },

                    {
                        path: "standards-ansi107",
                        component: ANSI107Standards,
                        name: 'ansi107standards'
                    },
                ]

            },

            {
                path: "/about-us",
                component: { template: '<router-view></router-view>' },
                children: [
                    {
                        path: "know-us",
                        component: KnowUs,
                        name: "knowus"
                    },
                    {
                        path: "locations",
                        component: Locations,
                        name: "locations"
                    },
                    {
                        path: "career-opportunities",
                        component: CareerOpportunities,
                        name: "careeropportunities"
                    },
                    {
                        path: "tradeshow-calendar",
                        component: TradeShow,
                        name: "tradeshowcalendar"
                    }
                ]
            },
            // {
            //     path: "/contact",
            //     component: Contact,
            //     name: 'contact'
            // },
            {
                path: "/brands",
                component: Brands,
                name: 'brand'
            },
            {
                path: "/NoAccess",
                name: 'no-access',
                component: NoAccess
            },
            {
                path: "/NoAdminAccess",
                name: 'no-admin-access',
                component: NoAdminAccess
            },
            {
                path: "/privacy-policy",
                name: 'privacy',
                component: PrivacyPolicy
            },
            {
                path: "/cookies",
                name: 'privacy',
                component: CookiePolicy
            },
            {
                path: "/auth/login",
                component: Login,
                name: "login",
            },
            // {
            //     path: "/auth/register",
            //     component: require("./auth/Register").default,
            //     name: "register",
            // },
            // {
            //     path: "/auth/login/verify/",
            //     component: require("./auth/Login").default,
            //     name: "verify",
            // },
            {
                path: '/reset-password',
                name: 'reset-password',
                component: ForgotPassword,
            },
            {
                path: '/reset-password/:token',
                name: 'reset-password-form',
                component: ResetPassword,
                meta: {
                    auth:false
                }
            },
            {
                path: "/myTools",
                component: MyTools,
                name: 'myTools',
                beforeEnter:guardMyroute,
            },
            {
                path: "/myAccount/",
                component: Account,
                name: 'myAccount',
                beforeEnter:guardMyroute,
            },
            {
                path: "/account/:id",
                component: EditUser,
                name: 'editUser',
                beforeEnter:guardAdminTools,
            },

            // {
            //     path: "/userList",
            //     component: UserList,
            //     name: 'userList',
            //     beforeEnter:guardMyroute,
            // },
            {
                path: "/ChangePassword",
                component: ChangePassword,
                name: "changePassword",
                beforeEnter:guardMyroute,
            },
            {
                path: "/ChangeUserPassword/:id",
                component: ChangeUserPassword,
                name: "changeUserPassword",
                beforeEnter:guardAdminTools,
            },
            {
                path: "/SpecSheetDownload/",
                component: SpecSheetDownload,
                name: "SpecSheetDownload",
                beforeEnter:guardMyroute,
            },
            {
                path: "/PriceListPortal/:customerId?",
                component: PriceListPortal,
                name: 'PriceListPortal',
                props: true,
                beforeEnter:guardMyPriceListPortal,
            },
            {
                path: "/PriceListVerify/",
                component: UnAuthorizedPriceListPortal,
                name: 'pricelist-verify'

            },
            {
                path: "/PriceWorkflowSubmission/",
                component: PriceWorkflowSubmission,
                name: "PriceWorkflowSubmission",
                beforeEnter:guardMyroute,
            },
            {
                path: "/PriceWorkflowCompanySelect/:ppId",
                component: PriceWorkflowCompanySelect,
                name: "PriceWorkflowCompanySelect",
                props: true,
                beforeEnter:guardMyroute,
            },
            {
                path: "/PriceWorkflowStyleSelect/:ppId",
                component: PriceWorkflowStyleSelect,
                name: "PriceWorkflowStyleSelect",
                props: true,
                beforeEnter:guardMyroute,
            },
            {
                path: "/PriceWorkflowSkuSelect/:ppId",
                component: PriceWorkflowSkuSelect,
                name: "PriceWorkflowSkuSelect",
                props: true,
                beforeEnter:guardMyroute,
            },
            {
                path: "/PriceWorkflowPricing/:ppId",
                component: PriceWorkflowPricing,
                name: "PriceWorkflowPricing",
                props: true,
                beforeEnter:guardMyroute,
            },
            {
                path: "/PriceWorkflowDashboards/:dashboard/:status?",
                component: PriceWorkflowDashboards,
                name: "PriceWorkflowDashboards",
                beforeEnter:guardMyroute,
            },
            {
                path: "/PriceWorkflowSignoff/:ppId",
                component: PriceWorkflowSignoff,
                name: "PriceWorkflowSignoff",
                props: true,
                beforeEnter:guardMyroute,
            },
            {
                path: "/PriceLevelSignoff/:ppId",
                component: PriceLevelSignoff,
                name: "PriceLevelSignoff",
                props: true,
                beforeEnter:guardMyroute,
            },
            {
                path: "/PriceWorkflowLevelDeviation/:ppId",
                component: PriceWorkflowLevelDeviation,
                name: "PriceWorkflowLevelDeviation",
                props: true,
                beforeEnter:guardMyroute,
            },
            {
                path: "/PriceWorkflowCustomDiscount/:ppId",
                component: PriceWorkflowCustomDiscount,
                name: "PriceWorkflowCustomDiscount",
                props: true,
                beforeEnter:guardMyroute,
            },
            {
                path: "/PriceWorkflowCustomDiscountSignoff/:ppId",
                component: PriceWorkflowCustomDiscountSignoff,
                name: "PriceWorkflowCustomDiscountSignoff",
                props: true,
                beforeEnter:guardMyroute,
            },
            {
                path: "/PriceWorkflowPromoType/:ppId",
                component: PriceWorkflowPromoType,
                name: "PriceWorkflowPromoType",
                props: true,
                beforeEnter:guardMyroute,
            },
            {
                path: "/PriceWorkflowPromoDetails/:ppId",
                component: PriceWorkflowPromoDetails,
                name: "PriceWorkflowPromoDetails",
                props: true,
                beforeEnter:guardMyroute,
            },
            {
                path:"/PriceWorkflowViewPromo/:ppId",
                component: PriceWorkflowViewPromo,
                name: "PriceWorkflowViewPromo",
                props: true,
                beforeEnter:guardMyroute,
            },
            {
                path:"/DynamicPriceList/",
                component: DynamicPriceList,
                name: "DynamicPriceList",
                beforeEnter:guardMyroute,
            },
            {
                path:"/ImageGallery/",
                component: ImageGallery,
                name: "ImageGallery",
                beforeEnter:guardMyroute,
            },
            {
                path:"/ImageGalleryResults/:prodId",
                component: ImageGalleryResults,
                name: "ImageGalleryResults",
                props: true,
                beforeEnter:guardMyroute,
            }
        ],
    },


    {
        path: "/specsheetPartOne/:id",
        component: SpecSheetPartOne,
        name: 'specsheetPartOne'
    },
    {
        path: "/specsheetPartTwo/:id",
        component: SpecSheetPartTwo,
        name: 'specsheetPartTwo'
    },

    // {
    //     path: "/auth/customer/login",
    //     component: CustomerLogin,
    //     name: "customerLogin",
    // },
    // {
    //     path: "/auth/customer/login/verify/",
    //     component: CustomerLogin,
    //     name: "customerVerify",
    // },



    {
        path: '/:catchAll(.*)',
        component: PageNotFound,
        name: 'pathNotFound'
    },



]

const router = new VueRouter({
    routes,
    mode: 'history',
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
          } else {
            return { x: 0, y: 0 }
          }
    }
});

router.beforeEach((toRoute, fromRoute, next) => {
    window.document.title = toRoute.meta && toRoute.meta.title ? toRoute.meta.title : 'West Chester Protective Gear';

    next();
  })

export default router;
